import { useState } from 'react';
import { debounce } from '@Utils/facade/lodash';
import { getValidator, rules } from '@Utils/shared/validator';
import useWidget from '@Utils/core/useWidget';
import { WidgetId } from '@Utils/edge/constants';

interface Values {
  playerId?: string;
}

const validationRules = {
  playerId: [rules.playerId],
};

const initialErrors = {
  playerId: '',
};

export const useValidate = () => {
  const [errors, setErrors] = useState(initialErrors);
  const logoThankYouContent = useWidget(WidgetId.LogoMakerThankYouRaidIdV3);

  const localizedErrors = {
    playerId: logoThankYouContent.strings.invalidFormatText,
  };

  const validator = getValidator(validationRules, localizedErrors);

  const validate = async (values: Values) => {
    try {
      setErrors(initialErrors);
      await validator(values);
      return Promise.resolve();
    } catch (error) {
      setErrors(error);
      return Promise.reject(error);
    }
  };

  const validateDebounced = debounce(validate, 150);

  return { validate, validateDebounced, errors, setErrors };
};
